import { 
  EuiFlexGroup,
    EuiFlexItem,
    EuiPage,
    EuiPageBody,
    EuiPageContent,
    EuiPageContentBody,
    EuiPageHeader,
    EuiPageHeaderSection,
    EuiTitle,} from '@elastic/eui';
  import React from 'react';
import { useLanguage } from '../../../../../../shared/hooks/Language';
import { InformeProvisionalDefinitivoMesAnteriorContainer } from './container';

  
  export const InformeProvisionalDefinitivoMesAnteriorView = () =>{
    
    const {translate} = useLanguage();
    
    return (
      <EuiPage>
      <EuiPageBody>
        <EuiPageHeader>
          <EuiFlexGroup>
            <EuiFlexItem>
              <EuiTitle size="l">
              <h1>{'Informe Diferencia Prov-Def Mes Anterior / Provisional'}</h1>
              </EuiTitle>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiPageHeader>
        <EuiPageContent>
          <EuiPageContentBody>
            <InformeProvisionalDefinitivoMesAnteriorContainer translate={translate}/>
          </EuiPageContentBody>
        </EuiPageContent>
      </EuiPageBody>
    </EuiPage>
    )
}